const getNarrativeLabels = state => state.definitions.narrativeSettings.labels;
const getNarrativeLabelCount = state => getNarrativeLabels(state).size;

const getNarrativeLabelAutoForFolderCount = state => getNarrativeLabels(state).filter(l => l.autoForFolder).size;
const getNarrativeLabelAutoForOtherCount = state => getNarrativeLabels(state).filter(l => l.autoForOther).size;

const getNarrativeNumbering = state => state.definitions.narrativeSettings.numbering;

const getNarrativeAutoDeleteItemWhenRemoveContainer = state =>
  state.definitions.narrativeSettings.autoDeleteWhenRemoveContainer;

const getNarrativeUsesStrictFolderStructure = state => state.definitions.narrativeSettings.strictFolderStructure;

export default {
  getNarrativeLabels,
  getNarrativeLabelCount,
  getNarrativeLabelAutoForFolderCount,
  getNarrativeLabelAutoForOtherCount,
  getNarrativeNumbering,
  getNarrativeAutoDeleteItemWhenRemoveContainer,
  getNarrativeUsesStrictFolderStructure
};
